<script setup>
/**
 * Once, for a phone that finished the welcome before it carried the terms
 * line: the terms changed, here they are. Not a wall: the app works behind it,
 * and OK puts it away for good.
 */
import { ref } from 'vue';
import { isDemo } from '../core/demo.js';
import { onboarded } from '../app-state.js';
import { markTermsSeen, openPrivacy, openTerms, termsSeen } from '../legal.js';

const open = ref(!isDemo.value && onboarded.value && !termsSeen());
function done() {
  markTermsSeen();
  open.value = false;
}
</script>

<template>
  <div v-if="open" class="terms-note" role="status">
    <p>
      We’ve updated our
      <button type="button" class="link" @click="openTerms">Terms of Use</button>
      and
      <button type="button" class="link" @click="openPrivacy">Privacy Policy</button>.
      Using Late Again means you agree to them.
    </p>
    <button type="button" class="ok" @click="done">OK</button>
  </div>
</template>

<style scoped>
.terms-note {
  position: fixed;
  left: 12px;
  right: 12px;
  bottom: calc(env(safe-area-inset-bottom, 0px) + 74px);
  z-index: 900;
  display: flex;
  align-items: center;
  gap: 12px;
  max-width: 560px;
  margin: 0 auto;
  padding: 12px 12px 12px 16px;
  background: var(--la-platform);
  color: var(--la-enamel);
  border: var(--la-control-border);
  border-radius: 12px;
  box-shadow: 0 12px 32px rgba(0, 0, 0, 0.35);
  font-family: var(--la-font-body);
  font-size: 13.5px;
  line-height: 1.45;
}
.terms-note p { margin: 0; flex: 1; }
.link {
  padding: 0;
  background: none;
  border: 0;
  color: inherit;
  font: inherit;
  text-decoration: underline;
  text-underline-offset: 2px;
  cursor: pointer;
}
.ok {
  flex: none;
  min-width: var(--la-control-min);
  min-height: var(--la-control-min);
  padding: 0 14px;
  background: var(--la-enamel);
  color: var(--la-carriage);
  border: 0;
  border-radius: 8px;
  font-family: var(--la-font-mono);
  font-size: 12px;
  letter-spacing: var(--la-control-track);
  cursor: pointer;
}
</style>
